import React, { FC, useEffect, useState } from 'react'
import { Portal } from './Portal'
import { RxCross1 } from 'react-icons/rx'
import './Modal.scss'

type Props = {
  isActive: boolean
  setIsActive: React.Dispatch<React.SetStateAction<boolean>>
  children: React.ReactNode
  className?: string
}

export const Modal: FC<Props> = ({ isActive, setIsActive, className, children }) => {
  const [isClosing, setIsClosing] = useState(false)

  const handleBackgroundClick = (e) => {
    if (e.target.classList.contains('modal-bg')) {
      closeModal()
    }
  }

  const closeModal = () => {
    setIsClosing(true)
    setTimeout(() => {
      setIsClosing(false)
      setIsActive(false)
    }, 300) 
  }

  useEffect(() => {
    if (isActive) {
      document.body.style.overflow = 'hidden'
    } else {
      document.body.style.overflow = ''
    }

    return () => {
      document.body.style.overflow = ''
    }
  }, [isActive])

  return isActive || isClosing ? (
    <Portal target='modal-root'>
      <div className={`modal-bg ${isActive && !isClosing ? 'fade-in' : 'fade-out'}`} onClick={handleBackgroundClick}>
        <div className={`modal ${className} ${isActive && !isClosing ? 'modal-show' : 'modal-hide'}`}>
          <div className='close' onClick={closeModal}>
            <RxCross1 />
          </div>
          {children}
        </div>
      </div>
    </Portal>
  ) : null
}
